import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge, Dropdown } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import breakimage from '../../../../images/auth/Front-break.jpg';
import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';


const FoodMap = () => {
    const tableRef = useRef(null);

       const [modalType, setModalType] = useState("");
        const [open, setOpen] = useState(false);
        const handleModalToggle_Edit = () => {
            setModalType("Edit");
            setOpen(true);
        };

    
    const [filterOpen, setFilterOpen] = useState(false);
    
    const onClose = () => {
        setFilterOpen(false);
    };

    
    
    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    "scrollX": true,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);


    return (
        <>
            <h1 className='mb-1 text-center' style={{ color: '#ea1d25' }}>Food Map</h1>
            <div className='d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0'>
                <div className='d-flex align-items-center gap-3'>
                    <div className="avatar-preview border rounded">
                        <img
                            id="saveImageFile"
                            src={breakimage}
                            alt="Packages"
                            className='w-80px h-80px'
                        />
                    </div>
                    <div>
                        <label className='text-black font-w400 fs-5'>Break Box</label>
                        <div className="d-block">
                            <label className="fs-6 text-dark">
                                <span>Mini</span>
                            </label>
                        </div>
                        <div className="d-block">
                            <Badge bg="info" className='text-white fs-8 py-0 px-1'>Weekly</Badge>
                        </div>
                    </div>
                </div>
                <div className='text-black font-w400'>
                    <label className='fs-6 font-w500 text-black'>Start Date &nbsp; - &nbsp;</label>
                    <Badge bg="success" className='text-white fs-6 py-0 px-1'>21-Jan-2025</Badge>
                    <div className='d-block mt-1'>
                        <label className='fs-6 font-w500 text-black'>End Date &nbsp;&nbsp;&nbsp; - &nbsp;</label>
                        <Badge bg="danger" className='text-white fs-6 py-0 px-1'>27-Jan-2025</Badge>
                    </div>
                </div>
                <div className='text-black text-center font-w400'>
                    <label className='fs-6 font-w500 text-black'>Service Time</label>
                    <div className='d-block mt-1'>
                        <Badge bg="warning" className='text-black fs-6 py-0 px-1'>07:00 AM - 08:00AM</Badge>
                    </div>
                </div>
                <div className='text-black text-center font-w400'>
                    <div className='d-flex align-items-center'>
                        <div className='mb-0 me-3'>
                            <div className='fs-5 font-w500 text-black'>
                                <span className='me-2'><i className='fas fa-user fs-4 text-info'></i></span>
                                <span>Raghavan</span>
                            </div>
                            <div className='d-block'>
                                <label className='fs-7 font-w500 text-black'>
                                    <span className='me-2'><i className='fas fa-phone fs-4 text-info'></i></span>
                                    <span>9803254464</span>
                                </label>
                            </div>
                            <div className='d-block text-center'>
                                <Link to={"#"} className="text-black font-w500" onClick={() => setFilterOpen(true)}>
                                    <span className='fs-8'><u>More Info</u></span>
                                </Link>
                            </div>
                        </div>
                        <Dropdown>
                            <Dropdown.Toggle
                                as="button"
                                variant="primary"
                                className="btn btn-primary text-white btn-sm"
                                id="tp-btn"
                            >
                                <span className='me-2'><i className="fa-solid fa-circle-down fs-8"></i></span>
                                <span className=''>Export</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item href="#" className='px-2'>
                                    <img
                                        src={csv_ico}
                                        alt="CSV"
                                        className='w-30px h-30px'
                                    />
                                    <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                                </Dropdown.Item>
                                <Dropdown.Item href="#" className='px-2'>
                                    <img
                                        src={excel_ico}
                                        alt="Excel"
                                        className='w-30px h-30px'
                                    />
                                    <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                                </Dropdown.Item>
                                <Dropdown.Item href="#" className='px-2'>
                                    <img
                                        src={print_ico}
                                        alt="Print"
                                        className='w-30px h-30px'
                                    />
                                    <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                                </Dropdown.Item>
                                {/* <Link to={'//PrintTripSheet'} className="btn btn-primary float-end btn-sm">
                                    <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                                    <span className=''>Add Vehicle</span>
                                </Link> */}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div className="table-container">
                <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-muted fw-bold fs-7 gs-0">
                            <th className='min-w-100px text-center'>Date</th>
                            <th className='min-w-150px text-center'>Main Course 1</th>
                            <th className='min-w-150px text-center'>Main Course 2</th>
                            <th className='min-w-150px text-center'>Side Dish 1</th>
                            <th className='min-w-150px text-center'>Side Dish 2</th>
                            <th className='min-w-100px text-center'>Order Status</th>
                            <th className='min-w-300px text-center'>Query's</th>
                            <th className='min-w-125px text-center'>Query's Status</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 text-center fw-semibold fs-8">
                        <tr>
                            <td>
                                <label className='text-black font-w500 fs-8'>21-Jan-2025</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>Tuesday</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>MULTIGRAIN ADAI (3)</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>நவ தனியா அடை</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>IDLY (3)</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>இட்லி</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>CORIANDER CHUTNEY</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>மல்லி சட்னி</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>SAMBAR</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>சாம்பார்</label>
                                </div>
                            </td>
                            <td className='text-center'>
                                <Badge bg="success" className='py-0 px-1 fs-8'>Delivered</Badge>
                            </td>
                            <td>
                                {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>To enable horizontal scrolling in your DataTable setup, you need to modify the table container to allow overflow when the table width exceeds the container's width.</span></Tooltip>} >
                                    <div className='text-black font-w400 fs-8 mw-100px text-truncate'>To enable horizontal scrolling in your DataTable setup, you need to modify the table container to allow overflow when the table width exceeds the container's width.</div>
                                </OverlayTrigger> */}
                                <div className='text-black font-w400 fs-8 mw-300px text-wrap text-justify'>Today Breakfast Multigrain adai spoiled and too salty.</div>
                                <div className='text-black text-end font-w600 fs-8 mt-2'>
                                    <label className='border rounded px-1 py-0'>By Subscriber</label>
                                </div>
                            </td>
                            <td className='text-center'>
                                <Badge bg="danger" className='py-0 px-1 fs-8'>Pending</Badge>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label className='text-black font-w500 fs-8'>22-Jan-2025</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>Wednesday</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>IDLY (3)</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>இட்லி</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>UTHAPPAM (3)</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>ஊத்தப்பம்</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>SAMBAR</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>சாம்பார்</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>CHILLI CHUTNEY</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>மிளகாய் சட்னி</label>
                                </div>
                            </td>
                            <td className='text-center'>
                                <Badge bg="warning" className='py-0 px-1 fs-8'>Scheduled</Badge>
                            </td>
                            <td>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                            <td className='text-center'>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label className='text-black font-w500 fs-8'>23-Jan-2025</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>Thursday</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>BUTTER MASALA DOSAI (2)</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>பட்டர் மசாலாதோசை</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>AVAL PONGAL</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>அவல் பொங்கல்</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>COCONUT CHUTNEY</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>தேங்காய் சட்னி</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>SAMBAR</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>சாம்பார்</label>
                                </div>
                            </td>
                            <td className='text-center'>
                                <Badge bg="warning" className='py-0 px-1 fs-8'>Scheduled</Badge>
                            </td>
                            <td>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                            <td className='text-center'>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label className='text-black font-w500 fs-8'>24-Jan-2025</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>Friday</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>VEG KITCHADI</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>வெஜ் கிச்சடி</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>KANCHIPURAM IDLY (3)</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>காஞ்சிபுரம் இட்லி</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>SAMBAR</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>சாம்பார்</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>TOMATO CHUTNEY</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>தக்காளி சட்னி</label>
                                </div>
                            </td>
                            <td className='text-center'>
                                <Badge bg="warning" className='py-0 px-1 fs-8'>Scheduled</Badge>
                            </td>
                            <td>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                            <td className='text-center'>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label className='text-black font-w500 fs-8'>25-Jan-2025</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>Saturday</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>CARROT UTHAPPAM (3)</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>கேரட் ஊத்தப்பம்</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>RAGI PUTTU</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>ராகி புட்டு</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>SPICY CHUTNEY</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>கார சட்னி</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>KADALAI CURRY</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>கடலை கறி</label>
                                </div>
                            </td>
                            <td className='text-center'>
                                <Badge bg="warning" className='py-0 px-1 fs-8'>Scheduled</Badge>
                            </td>
                            <td>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                            <td className='text-center'>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label className='text-black font-w500 fs-8'>26-Jan-2025</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>Sunday</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>IDLY (3)</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>இட்லி</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>COCONUT SEVAI</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>தேங்காய் சேவை</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>SAMBAR</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>சாம்பார்</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>CORIANDER CHUTNEY</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>மல்லி சட்னி</label>
                                </div>
                            </td>
                            <td className='text-center'>
                                <Badge bg="warning" className='py-0 px-1 fs-8'>Scheduled</Badge>
                            </td>
                            <td>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                            <td className='text-center'>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label className='text-black font-w500 fs-8'>27-Jan-2025</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>Monday</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>SPL VEN PONGAL</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>ஸ்பெஷல்  வெண் பொங்கல்</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>POORI (3)</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>பூரி</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>SAMBAR</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>சாம்பார்</label>
                                </div>
                            </td>
                            <td>
                                <label className='text-black font-w500 fs-8'>POTATO MASALA</label>
                                <div className='d-block'>
                                    <label className='text-black font-w400 fs-9'>உருளை மசாலா</label>
                                </div>
                            </td>
                            <td className='text-center'>
                                <Badge bg="warning" className='py-0 px-1 fs-8'>Scheduled</Badge>
                            </td>
                            <td>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                            <td className='text-center'>
                                <div className='text-black font-w600 fs-8 text-center'>-</div>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>


            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(), 
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                    width: 400, 
                    boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                    '& .MuiDrawer-paper': {
                        width: 320,
                    },
                    },
                    '@media (max-width: 320px)': {
                    '& .MuiDrawer-paper': {
                        width: 280, 
                    },
                    },
                }}
                >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Subscriber Info</h5>
                    <div>
                    <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                        <span className='fs-2'>×</span>
                    </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className="row mb-2 py-1 mt-3">
                            <label className="col-4 text-black fs-7">Subscriber</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">Raghavan</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Gender</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">Male</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Mobile No</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">9803254464</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Alternate No</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">8803254464</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Email ID</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">raghavan@gmail.com</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Area</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">Anna Nagar</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Delivery Point</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">Anna Nagar</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Latitude</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">99.9209149</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Longitute</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">78.14056002</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Address - 1</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">6th East Cross Street, 80 Feet Road, Madurai</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Address - 2</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">-</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-4 text-black fs-7">Pincode</label>
                            <label className="col-1 text-black fs-6">:</label>
                            <label className="col-7 text-black font-w500 fs-6">625012</label>
                        </div>
                        <div className="row mb-2 py-1">
                            <label className="col-12 text-black fs-7">Description</label>
                            <label className="col-12 text-black font-w500 fs-6">&emsp;&emsp; -</label>
                        </div>
                    </div>
                </div>
            </Drawer>
     
        </>
    )


}
export default FoodMap;